export default ({ app, redirect }, inject) => {
  inject('redirect', (path, statusCode = 302) => {
    const target = path.match(/^https?:\/\//ig) ? path : app.localePath(path)
    if (process.client) {
      if (target.match(/^https?:\/\//i)) {
        window.location = target
        return
      }
      if (typeof window.$nuxt !== 'undefined') return window.$nuxt.$router.push(target)
      return window.onNuxtReady(() => { window.$nuxt.$router.push(target) })
    }
    return redirect(statusCode, target)
  })
}